import type { HelpFile } from '../../types/help'
import { MyRequestsTestIds } from '../../../testids/MyRequestsTestIds'

export const myRequestsHelp: HelpFile = {
  docPage: '/docs/my-iam/my-requests',
  texts: {
    [MyRequestsTestIds.myRequestsPage]:
      'Access requests and function-group requests submitted here or benefiting this identity — track approval status and cancel pending items.',
    [MyRequestsTestIds.colBeneficiary]: 'Identity that receives access when the request is approved.',
    [MyRequestsTestIds.colItems]: 'Number of Access Profiles or roles in this request.',
    [MyRequestsTestIds.colJustification]: 'Business reason given when the request was submitted.',
    [MyRequestsTestIds.colFgBeneficiary]: 'Identity that receives the function-group assignment.',
    [MyRequestsTestIds.colFgCreatedAt]: null,
    [MyRequestsTestIds.colFgItems]: 'Number of function groups included in this request.',
    [MyRequestsTestIds.colFgJustification]: 'Business reason given for the function-group request.',
  },
}
